/**
 * SEO utility: actualiza title, description y Open Graph por página.
 * Importar en cada componente y llamar dentro de un useEffect.
 *
 * Uso:
 *   import { setSEO } from '../lib/seo';
 *   useEffect(() => { setSEO({ title: '...', description: '...' }); }, []);
 */
export function setSEO({ title, description, canonical }) {
  if (!title || !description) return;

  document.title = title;

  const set = (selector, attr, value) => {
    const el = document.querySelector(selector);
    if (el) el.setAttribute(attr, value);
  };

  set('meta[name="description"]',        'content', description);
  set('meta[property="og:title"]',        'content', title);
  set('meta[property="og:description"]', 'content', description);
  set('meta[name="twitter:title"]',       'content', title);
  set('meta[name="twitter:description"]', 'content', description);
  if (canonical) set('link[rel="canonical"]', 'href', canonical);
}
